module.exports = __webpack_public_path__ + "img/12600.918d412e.jpg";